const frca = Object.freeze({
  siteId: process.env.SEARCHSPRING_SITE_ID_FR_CA,
})

const enca = Object.freeze({
  siteId: process.env.SEARCHSPRING_SITE_ID_EN_CA,
})

const enus = Object.freeze({
  siteId: process.env.SEARCHSPRING_SITE_ID_EN_US,
})

const eneu = Object.freeze({
  siteId: process.env.SEARCHSPRING_SITE_ID_EN_EU,
})

const freu = Object.freeze({
  siteId: process.env.SEARCHSPRING_SITE_ID_FR_EU,
})

export default {
  'fr-ca': frca,
  'en-ca': enca,
  'en-us': enus,
  'en-eu': eneu,
  'fr-eu': freu,
}
